var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaCityBreakFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.45,8.11a1.48321,1.48321,0,0,0-1.3-.74H6.32V4.21H4.21V.53A.53351.53351,0,0,0,3.89.04.52278.52278,0,0,0,3.68,0a.46488.46488,0,0,0-.36.16L1.21,2.26a.51331.51331,0,0,0,0,.74.50787.50787,0,0,0,.74,0L3.16,1.8V4.21H1.05V7.45A1.52582,1.52582,0,0,0,0,8.91V20H13.69V8.91A1.44948,1.44948,0,0,0,13.45,8.11ZM2.11,5.26H5.26V7.37H2.11Zm8.94,12.11H2.63V16.32h8.42Zm0-2.11H2.63V14.21h8.42Zm0-2.1H2.63V12.11h8.42Zm0-2.11H2.63V10h8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,2.16V1.44A1.45545,1.45545,0,0,0,16.45,0H13.02a1.44681,1.44681,0,0,0-1.44,1.44v.72A2.58962,2.58962,0,0,0,9.47,4.71V6.32h2.68a2.58375,2.58375,0,0,1,1.8.73h3.42V8.11H14.61a2.39571,2.39571,0,0,1,.13.8v.46h2.63v1.05H14.74v1.26h2.63v1.06H14.74V14h2.63v1.05H14.74v1.27h2.63v1.05H14.74V20H20V4.71A2.59535,2.59535,0,0,0,17.9,2.16Zm-5.27-.72a.39712.39712,0,0,1,.39-.39h3.43a.39712.39712,0,0,1,.39.39v.67H12.63Zm-.52,4.35V4.74h5.26V5.79Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaCityBreakFill);
export default __webpack_public_path__ + "static/media/iconaCityBreakFill.27448e3ba48a0ee9cef570b9148a6f3b.svg";
export { ForwardRef as ReactComponent };